module.exports = __webpack_public_path__ + "html/fuel-table.template.html";